import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { Box, Grid } from '@mui/material';
import { withTranslation } from 'react-i18next';

@inject('orderStore')
@observer
class OrderStep extends Component {
  render() {
    const { orderStore, t } = this.props;

    return (
      <Box className="step-container" bgcolor="primary.main">
        <Grid container direction="row" alignItems="center">
          <Grid
            item
            xs
            className={'step-item step-payment ' + (orderStore.order.currentStatusCode === 1 ? 'active' : '')}
          >
            <div className="step-title">{t('payment.label.completed')}</div>
          </Grid>
          <Grid
            item
            xs
            className={'step-item step-order ' + (orderStore.order.currentStatusCode === 2 ? 'active' : '')}
          >
            <div className="step-title">{t('order.label.receive')}</div>
          </Grid>
          <Grid
            item
            xs
            className={'step-item step-ready ' + (orderStore.order.currentStatusCode === 3 ? 'active' : '')}
          >
            <div className="step-title">{t('order.label.ready')}</div>
          </Grid>
          <Grid
            item
            xs
            className={'step-item step-pickup ' + (orderStore.order.currentStatusCode === 4 ? 'active' : '')}
          >
            <div className="step-title">{t('order.label.pickup')}</div>
          </Grid>
        </Grid>
      </Box>
    );
  }
}

export default withRouter(withTranslation()(OrderStep));
